export const environment = {
  production: false,
  environment: 'development',
  // Use relative URLs since frontend and backend are on same domain (us-east-1.dev.midoc.io)
  // Works whether accessed via app.scryber.ai (Cloudflare) or us-east-1.dev.midoc.io directly
  apiUrl: '/api',
  transcriptionApiUrl: '/api/upload-and-transcribe',
  // Backend URL for OAuth2 — same origin as the SPA (app.scryber.ai)
  backendUrl: 'https://app.scryber.ai',
  apiKey: 'testme',
  enableLogging: true,
  enableDebugMode: true,
  version: '1.0.0-dev'
};
